// Function to redirect user to login page
export const redirectToLogin = () => {
  // Clear any existing tokens
  localStorage.clear();
 
  // Redirect to login page
  window.location.href = '/login';
}; 